import { render, staticRenderFns } from "./VideoCrawlerTagExample.vue?vue&type=template&id=cb26230c&scoped=true&"
import script from "./VideoCrawlerTagExample.vue?vue&type=script&lang=js&"
export * from "./VideoCrawlerTagExample.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb26230c",
  null
  
)

export default component.exports